<template>
    <div class="row">
        <div class="btn-group" role="group" aria-label="Botones de acción">
            <button type="button" class="btn btn-default btn" @click="descargar(datosurl)" title="Descarga PDF">
                <i class="fas fa-file-pdf"></i>
            </button>
            <button type="button" class="btn btn-default btn"  @click="descargar(datosexcel)" title="Descargar Excel">
                <i class="fas fa-file-excel"></i>
            </button>            
        </div>
        <div class="col" v-if="this.$props.presupuesto.presupuesto.operarios_idoperario > 0">
            <div v-for="(label, value) in estados" :key="value" class="form-check form-check-inline" style="margin-left:10px;">
            <input
                class="form-check-input"
                type="radio"
                :id="'estado-' + value"
                name="estado"
                :value="value"
                v-model="this.$props.presupuesto.presupuesto.presupuesto_activo_factura"
                @change="estadoPresupuesto(this.$props.idfactura,value)"
            />
            <label class="form-check-label" :for="'estado-' + value">
                {{ label }}
            </label>
            </div>
        </div>
        <div class="col" v-else>
            <div class="custom-control custom-switch custom-switch-on-success" v-if="this.$props.presupuesto.presupuesto.estado != 2" style="margin-left:10px;">
                <input v-model="estado_aprobado" @change="desaprobar(this.$props.idfactura)" type="checkbox" class="custom-control-input" :id="'aprobado_' + this.$props.idfactura">
                <label class="custom-control-label" :for="'aprobado_' + this.$props.idfactura">Aprobado</label>
            </div>
        </div>
        <div class="btn-group" role="group" aria-label="Botones de acción">
            <button v-if="this.servicio.compania.sistema == 'AXA_WS'" :disabled="!axaCorrecto" type="button" class="btn btn-info btn" :title="axaCorrecto?'Envío AXA':'Hay trabajos que no son de axa'" @click="mostrarResumenAxa()">
                <i class="fas fa-font "></i>
            </button> 
            <button type="button" class="btn btn-secondary btn" title="Mostrar gestor de documentos" v-if="mostrarBotonGestor" @click="comprobarGestorDoc">
                <i class="fas fa-paste"></i>
            </button>
            <button type="button" v-if="this.$props.presupuesto.presupuesto.estado != 2 && (this.$props.presupuesto.presupuesto.id_presupuesto_compania == '' && this.$props.presupuesto.presupuesto.version == '')" class="btn btn-warning btn" title="Anular" @click="anular(this.$props.idfactura)">
                <i class="fas fa-exclamation-circle"></i>
            </button> 
         <!--   <button type="button" class="btn btn-danger btn" v-if="this.$props.presupuesto.presupuesto.estado != 2" title="Eliminar" @click="eliminar(this.$props.idfactura)">
                <i class="fas fa-trash"></i>
            </button> -->
        </div>
    </div>
    <div v-if="mostrarEnvios">
        <div class="col-md-12">
            <div class="card card-default" style="width:100%">
                <div class="card-header bg-default">
                    <h3 class="card-title">Envíos</h3>  
                </div>
                <div class="card-body">
                    <div>
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>
                                        Tipo
                                    </th>
                                    <th>
                                        Destino
                                    </th>
                                    <th>
                                        Fecha
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="envio in envios_presupuesto" :key="envio.id_envio">
                                    <td>
                                        {{ envio.tipo_envio }}
                                    </td>
                                    <td>
                                        {{ envio.destino_envio }} 
                                    </td>
                                    <td>
                                        {{ envio.fecha_envio }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row" v-if="this.$props.presupuesto.presupuesto.estado != 2">
        <div class="col-md-12">
            <div class="row">
                <div class="card card-default" style="width:100%">
                    <div class="card-header bg-default">
                        <h3 class="card-title"><i class="fab fa-telegram-plane mr-2"></i>Enviar</h3>  
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col">
                                <select class="form-control input-sm" v-model="tipodeenvio">
                                    <option v-for="(envios, key) in this.$props.presupuesto.envios_disponibles" :key="key" :value="key">{{envios}}</option>
                                </select>
                            </div>
                            <div class="col">
                            <!--  <v-select taggable multiple placeholder="Seleccione destinatario" :options="listacorreos" />        -->    
                                <MultiSelect v-if="tipodeenvio=='email'" v-model="emailsenviar" :options="emailsPresu" display="chip" optionGroupLabel="tipo" optionGroupChildren="email" placeholder="Selecciona emails" :maxSelectedLabels="3"  >
                                <template #option="slotProps">
                                    <div>{{ slotProps.option }}</div>
                                </template>
                            </MultiSelect>                       </div>
                        </div>
                        <div class="row" v-if="tipodeenvio=='email'">
                            <div class="col">
                                <input type="text" v-model="otrosdestinatarios" placeholder="Otros destinatarios, separados por ;" class="form-control">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <textarea class="form-control" rows="3" placeholder="Introducir texto del mensaje" v-model="descripcionemail"></textarea>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <button type="button" class="btn btn-block btn-sm btn-outline-primary " @click="enviarpresupuesto()">Enviar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row" v-if="mostrarGestor">
        <div class="col-md-12">
            <div style="height: 50px; position: relative;" class="loading-spinner"  v-if="cargandoDocumentos">
                <div style="position: absolute; inset: 0; margin: auto; height: fit-content; width: fit-content">
                    <i class="fas fa-spinner fa-spin"></i> Cargando...
                </div>            
            </div>
            <div v-else class="row">
                <div class="card card-default" style="width:100%">
                    <div class="card-header">
                        <h4 class="card-title">Gestor documentos</h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12" style="display: grid;row-gap: 15px; height: fit-content;">
                                <div class="row" style="margin-left: 0;">
                                    <div style="display: grid; width: 60%;">
                                        <label for="documentos">Documento</label>
                                        <select id="documentos" class="form-control" style="width: 90%;" v-model="documentoSeleccionado">
                                            <option value="sin doc">Selecciona un documento</option>
                                            <option v-for="documento in documentosPresupuesto" :key="documento.id_documento" :value="documento.id_documento">{{ documento.nombre }}</option>
                                        </select>
                                    </div>
                                    <div style="display: grid; align-items: end;">
                                        <button class="btn  btn-light border-secondary" @click="generarDocumento">Generar</button>
                                    </div>
                                </div>
                                <div v-if="generadosVisible" style="display: grid; row-gap: 15px;">
                                    <div v-for="(separados) in Object.entries(docsSeparados)" :key="separados[0]">
                                        <div class="card card-primary">
                                            <div class="card-header p-3">
                                                <div ><span >Documentos de {{ separados[0] }}</span></div>
                                            </div>
                                            <div class="card-body">
                                                <div v-for="doc in separados[1]" :key="doc.id_documento_generado" class="card" style="border-left:6px solid #117a8b;">
                                                    <div class="card-header p-1">
                                                        <div class="row" style="gap: 15px; align-items: center; margin: 0;">
                                                                <span>{{ sacarfecha(doc.fecha_generado) }}</span>
                                                                <button class="btn btn-light" v-if=" botones[doc.id_documento_generado].includes('docx')" @click="descargar(doc.url_completa_descarga_docx)" style="color: DodgerBlue;" title="Descarga DOCX"><i class="fas fa-file-word"></i></button>
                                                                <button class="btn btn-light" v-if=" botones[doc.id_documento_generado].includes('excel')" @click="descargar(doc.url_completa_descarga_docx)" style="color: MediumSeaGreen;" title="Descarga XLSX"><i class="fas fa-file-excel"></i></button>
                                                                <button class="btn btn-light" v-if=" botones[doc.id_documento_generado].includes('pdf')" @click="descargar(doc.url_completa_descarga_pdf)" style="color: FireBrick;" title="Descarga PDF"><i class="fas fa-file-pdf"></i></button>
                                                                <button class="btn btn-light" v-if=" botones[doc.id_documento_generado].includes('pdff')" @click="descargar(doc.url_completa_descarga_pdf_firmado)" style="color: Crimson;" title="Descarga PDF Firmado"><i class="fas fa-file-signature"></i></button>
                                                                <button class="btn btn-light" v-if=" botones[doc.id_documento_generado].includes('png')" @click="descargar(doc.url_completa_descarga_png)" style="color: Teal;" title="Descarga JPG"><i class="fas fa-file-contract"></i></button>
                                                                <button class="btn btn-sm btn-light" style="border: 1px solid grey;" @click="visibleForm[doc.id_documento_generado] = !visibleForm[doc.id_documento_generado]">Enviar</button>
                                                                <button class="btn btn-sm btn-light" style="border: 1px solid grey;" @click="confirmarEliminar(doc.id_documento_generado)">Eliminar</button>
                                                                <button class="btn btn-sm btn-light" style="border: 1px solid grey;" @click="visibleEnvios[doc.id_documento_generado] = !visibleEnvios[doc.id_documento_generado]">Envíos</button>
                                                            </div>
                                                    </div>
                                                    <div class="card-body" v-if="docsEnviados[doc.id_documento_generado].length>0 || visibleForm[doc.id_documento_generado]">
                                                        <div v-if="visibleForm[doc.id_documento_generado]" style="width: 90%;">
                                                            <div class="form-group">
                                                                    <label for="envio">Tipo envio</label>
                                                                    <div>
                                                                        <select class="form-control" v-model="envioSeleccionado[doc.id_documento_generado]" id="envio">
                                                                            <option value="email">Email</option>
                                                                            <option value="pap" v-if="pap">PAP</option>
                                                                        </select>
                                                                    </div>
                                                            </div>
                                                            <div class="form-group">
                                                                <label for="doc">Tipo Documento</label>
                                                                <div>
                                                                    <select class="form-control" v-model="docSeleccionado[doc.id_documento_generado]" id="doc">
                                                                        <option value="pdf">PDF</option>
                                                                        <option :value="extensiones[doc.id_documento_generado]">{{ extensiones[doc.id_documento_generado] }}</option>
                                                                    </select>
                                                                </div>                                                    
                                                            </div>
                                                            <div class="form-group" v-if="pap">
                                                                <label for="docPAP">Tipo documento PAP</label>
                                                                <div>
                                                                    <select class="form-control" v-model="PAPSeleccionado[doc.id_documento_generado]" id="docPAP">
                                                                        <option value="">Seleccione</option>
                                                                        <option  v-for="papoption in tipo_doc_pap[doc.id_documento_generado]" :value="papoption.valor" :key="papoption">{{ papoption.texto }}</option>
                                                                    </select>
                                                                </div>                                                      
                                                            </div>
                                                            <div class="form-group">
                                                                <label for="email">Email</label>
                                                                <div style="display: grid; row-gap: 15px;">
                                                                    <select class="form-control" v-model="emailSeleccionado[doc.id_documento_generado]" id="email">
                                                                        <option value="">Seleccione</option>
                                                                        <option  v-for="email in emails[doc.id_documento_generado]" :value="email.email" :key="email.email">{{ email.nombre }}</option>
                                                                    </select>
                                                                    <input class="form-control" v-model="emailIntroducido[doc.id_documento_generado]" type="text" placeholder="Introducir email">
                                                                </div>
                                                            </div>
                                                            <div class="form-group">
                                                                <label for="asunto">Asunto</label>
                                                                <input class="form-control" v-model="asuntoSeleccionado[doc.id_documento_generado]" id="asunto" type="text">
                                                            </div>
                                                            <div class="form-group">
                                                                <label for="texto">Texto</label>
                                                                <div>
                                                                    <textarea class="form-control" id="texto" v-model="ta[doc.id_documento_generado]"></textarea>
                                                                </div>
                                                            </div>
                                                            <div class="row" style="column-gap: 15px; margin: 0; justify-content: end;">
                                                                <button class="btn btn-sm btn-light" style="border: 1px solid grey;" @click="guardarForm(doc.id_documento_generado)">Enviar</button>
                                                                <button class="btn btn-sm btn-light" style="border: 1px solid grey;" @click="visibleForm[doc.id_documento_generado]=false">Cerrar</button>
                                                            </div>
                                                        </div>
                                                        <hr v-if="docsEnviados[doc.id_documento_generado].length>0 && visibleForm[doc.id_documento_generado] && visibleEnvios[doc.id_documento_generado]"/>
                                                        <div  v-if="docsEnviados[doc.id_documento_generado].length>0 && visibleEnvios[doc.id_documento_generado]" style="display: grid;margin-top: 15px;">
                                                            <table class="table table-sm">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Fecha envío</th>
                                                                        <th>Destinatario</th>
                                                                        <th>Usuario</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody v-for="(docEnv, index) in docsEnviados[doc.id_documento_generado]" :key="docEnv.id_documento_envio">
                                                                    <tr v-if="index%2==0" style="background-color: rgba(0, 0, 0, .05)">
                                                                        <td>{{ docEnv.fecha_envio }}</td>
                                                                        <td>{{ docEnv.destinatario_envio }}</td>
                                                                        <td><i class="fas fa-info-circle" style="cursor: pointer;" @click="infoExtraVisible[docEnv.id_documento_envio]=!infoExtraVisible[docEnv.id_documento_envio]"></i>{{ docEnv.usuario }}</td>
                                                                        
                                                                    </tr>
                                                                    <tr v-else style="background-color: white;">
                                                                        <td>{{ docEnv.fecha_envio }}</td>
                                                                        <td>{{ docEnv.destinatario_envio }}</td>
                                                                        <td><i class="fas fa-info-circle" style="cursor: pointer;" @click="infoExtraVisible[docEnv.id_documento_envio]=!infoExtraVisible[docEnv.id_documento_envio]"></i>{{ docEnv.usuario }}</td>
                                                                    </tr>
                                                                    <tr   v-if="infoExtraVisible[docEnv.id_documento_envio] && index%2==0" style="background-color: rgba(0, 0, 0, .05)">
                                                                        <td colspan="3">Texto enviado: {{ docEnv.texto_envio }}</td>
                                                                    </tr>
                                                                    <tr  v-else-if="infoExtraVisible[docEnv.id_documento_envio]" style="background-color: white;">
                                                                        <td colspan="3">Texto enviado: {{ docEnv.texto_envio }}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        
                                    </div>
                                </div>                                
                            </div>
                            <div class="col-md-6">
                                <div class="row" style="justify-content: space-around;row-gap: 10px;" v-if="imagenes">
                                    <div v-for="img in Object.entries(imagenes)" :key="img[1].id_documento">
                                        <div style="display: grid; row-gap: 10px;">
                                            <Image v-if="urlglobal != 'null.pwgs.app'" :src='img[1].url_completa_descarga' style="border: 5px solid goldenrod;" width="100" preview :alt="img[1].descripcion" />
                                            <Image v-else :src='"https://desarrollo.pwgs.app/documentos.php?documento="  + img[1].documento + "&servicio=" +id' style="border: 5px solid goldenrod;" width="100" preview :alt="img[1].descripcion" />
                                            <input type="checkbox" v-model="activado[img[1].id_documento]">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Dialog :visible="mostrarResumen" :style="{width: '50vw'}" header="Resumen valoración AXA" :closable="false">
        <div v-if="cargandoResumen">
            <div class="d-flex justify-content-center">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Cargando...</span>
                </div>
            </div>
        </div>
        <div v-if="enviandoAxa">
            <div class="d-flex justify-content-center">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Enviando...</span>
                </div>
            </div>
        </div>
        <div v-else v-for="grupoAfectado in gruposAfectadosPresupuestosTemporales" :key="grupoAfectado.idAfectado" class="card card-primary">
            <div class="card-header">
                {{ grupoAfectado.afectado }}
            </div>
            <div class="card-body">
                <div v-for="presupuesto in grupoAfectado.presupuestosTemporales" :key="presupuesto" class="card card-secondary">
                    <div class="card-header">                                        
                        {{ presupuesto.especialidad }} - Presupuestar por: {{ presupuesto.presupuestarPor }}                                                                                   
                    </div>
                    <div v-if="presupuesto.trabajos.length == 0 && presupuesto.materiales.length == 0" class="card-body">
                        No hay trabajos ni materiales
                    </div>
                    <div v-else class="card-body">
                        <div style="display: grid; gap: 15px">                                    
                            <div>
                                <label for="">Trabajos</label>
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>
                                                Categoria
                                            </th>
                                            <th>
                                                Linea
                                            </th>
                                            <th>
                                                Uds
                                            </th>
                                            <th>
                                                Precio
                                            </th>
                                            <th>
                                                IVA (%)
                                            </th>
                                            <th>
                                                Total
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="trabajo in presupuesto.trabajos" :key="trabajo">
                                            <td>
                                                {{ trabajo.trabajo.nombre_categoria }}
                                            </td>
                                            <td>
                                                {{ trabajo.trabajo.desc_linea }}
                                            </td>
                                            <td>
                                                {{ trabajo.Cantidad }}
                                            </td>
                                            <td>
                                                {{ trabajo.TotalSinIva }}
                                            </td>
                                            <td>
                                                {{ trabajo.IvaSeleccionado }}
                                            </td>
                                            <td>
                                                {{ trabajo.TotalConIva }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div>
                                <label for="">Materiales</label>
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>
                                                Tipo
                                            </th>
                                            <th>
                                                Descripción
                                            </th>
                                            <th>
                                                Uds
                                            </th>
                                            <th>
                                                Precio
                                            </th>
                                            <th>
                                                IVA (%)
                                            </th>
                                            <th>
                                                Total
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="material in presupuesto.materiales" :key="material">
                                            <td>
                                                otros
                                            </td>
                                            <td>
                                                {{ material.Descripcion }}
                                            </td>
                                            <td>
                                                {{ material.Cantidad }}
                                            </td>
                                            <td>
                                                {{ material.trabajo.precioUnidad }}
                                            </td>
                                            <td>
                                                {{ material.IvaSeleccionado }}
                                            </td>
                                            <td>
                                                {{ material.TotalConIva }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>       
                            <div v-if="presupuesto.presupuestarPor == 'M.O.'">
                                <label for="">Desplazamiento</label>
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>
                                                Kms
                                            </th>
                                            <th>
                                                Mínimo
                                            </th>
                                            <th>
                                                Kms netos
                                            </th>
                                            <th>
                                                Precio
                                            </th>
                                            <th>
                                                IVA (%)
                                            </th>
                                            <th>
                                                Total
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="desplazamiento in presupuesto.desplazamiento" :key="desplazamiento">
                                            <td>
                                                {{ desplazamiento.Cantidad }}
                                            </td>
                                            <td>
                                                {{ desplazamiento.trabajo.minKmFacturables }}
                                            </td>
                                            <td>
                                                {{ desplazamiento.trabajo.unidadesAFacturar }}
                                            </td>
                                            <td>
                                                {{ desplazamiento.trabajo.precio }}
                                            </td>
                                            <td>
                                                {{ desplazamiento.IvaSeleccionado }}
                                            </td>
                                            <td>
                                                {{ desplazamiento.TotalConIva }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div style="margin: 15px 0;">
                                <label for="">TOTAL OFICIO</label>
                                <table v-if="presupuesto.presupuestarPor=='baremo'" class="table">
                                    <thead>
                                        <tr>
                                            <th>
                                                Baremo
                                            </th>
                                            <th>
                                                MATS.
                                            </th>
                                            <th>
                                                IVA(%)
                                            </th>
                                            <th>
                                                TOTAL
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                {{ presupuesto.totalBaremo }}
                                            </td>
                                            <td>
                                                {{ presupuesto.totalMateriales }}
                                            </td>
                                            <td>
                                                {{ presupuesto.totalIva }}
                                            </td>
                                            <td>
                                                {{ presupuesto.total }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table v-else class="table">
                                    <thead>
                                        <tr>
                                            <th>
                                                M.O.
                                            </th>
                                            <th>
                                                MATS.
                                            </th>
                                            <th>
                                                DESPL.
                                            </th>
                                            <th>
                                                IVA (€)
                                            </th>
                                            <th>
                                                TOTAL
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                {{ presupuesto.totalBaremo }}
                                            </td>
                                            <td>
                                                {{ presupuesto.totalMateriales }}
                                            </td>
                                            <td>
                                                {{ presupuesto.totalDesplazamiento }}
                                            </td>
                                            <td>
                                                {{ presupuesto.totalIva }}
                                            </td>
                                            <td>
                                                {{ presupuesto.total }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div> 
                            <div>
                                <label for="">Comentario</label>
                                <textarea v-model="presupuesto.comentario" rows="2" class="form-control" id=""></textarea>
                            </div>
                        </div>                                
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <label>Resumen valoración</label>
                <div style="display: flex; gap: 25px; margin-top: 15px">
                    <div style="display: grid; grid-template-columns: 2fr 1fr; align-items: center">
                        <span style="margin: 0;" for="">Total a liquidar reparador</span>
                        <input type="text" class="form-control" readonly :value="grupoAfectado.liquidar_reparador">
                    </div>
                    <div style="display: grid; grid-template-columns: 2fr 1fr; align-items: center">
                        <span style="margin: 0;" for="">Total a liquidar cliente</span>
                        <input type="text" class="form-control" readonly :value="grupoAfectado.liquidar_cliente">
                    </div>
                </div>
                <div style="display: flex; justify-content: end;align-items: end; margin-top: 20px">
                    <button class="btn btn-primary" @click="guardarValoracion(grupoAfectado)">Guardar valoración</button>
                </div>
            </div>
        </div> 
        <template #footer>
            <Button label="Cancelar" @click="mostrarResumen = false" class="btn-default" />
        </template>
    </Dialog>
</template>
<script>

import Dialog from 'primevue/dialog';
import { PwgsApi } from '../../../../../../services/PwgsApi';
import MultiSelect from 'primevue/multiselect';

export default ({
    props: ['id', 'seleccionado','presupuesto','correo','idfactura', 'servicio','idfotosseleciconadas'],
    data() {
        return {
            mostrarBotonGestor:false,
            descripcionemail:'',
            enviandoAxa:false,
            envios_presupuesto:[],
            mostrarEnvios:false,
            pap:false,
            codigo:'',
            documentoSeleccionado:'sin doc',
            cargandoDocumentos:false,
            documentosPresupuesto:null,
            mostrarGestor:false,
            listacorreos: [],
            datosurl: "",
            url: "",
            urlexcel: "",
            datosexcel: "",
            tipodeenvio: "email",
            correoseleccionado: "",
            estado: this.$props.presupuesto.presupuesto.presupuesto_activo_factura, 
            estado_aprobado: false,  
            emailsPresu: [],
            otrosdestinatarios: '',
            emailsenviar:[],
            docsGenerados: [],
            docsSeparados: [],
            docsEnviados: [],
            botones: [],
            visibleForm: [],
            visibleEnvios: [],
            infoExtraVisible: [],
            imagenes: [],
            extensiones: [],
            tipo_doc_pap:[],
            envioSeleccionado: [],
            docSeleccionado: [],
            PAPSeleccionado: [],
            emailSeleccionado: [],
            emails:[],
            emailIntroducido: [],
            ta: [],
            asuntoSeleccionado: [],
            estados: {
                '0': 'En revisión',
                '1': 'Aceptado',
                '2': 'Denegado',
            },
            axaCorrecto:true,
            cargandoResumen:false,
            gruposAfectadosPresupuestosTemporales: [],
            afectadosValoraciones:[],
            mostrarResumen:false,
        }
    },
    setup() {
        return;
    },
    components: {
        MultiSelect,
        Dialog,
    },
    methods: {
        async guardarValoracion(grupoAfectado){
            this.enviandoAxa = true;
            const api = new PwgsApi();  
            var envio = {
                TipoOperacion:"MANAGE_PREVAL",
                TipoPrepVal:"V",
                IdEncargo:"",
                IdAfectado:grupoAfectado.idAfectado,
                Oficios:[],
            }
            var total = 0;
            console.log('envio', grupoAfectado);
            grupoAfectado.presupuestosTemporales.forEach(presupuesto => {
                var oficio = {
                    IdEspecialidad: presupuesto.idEspecialidad,
                    Indice: presupuesto.indice,
                    Comentario: presupuesto.comentario,
                }
                if(presupuesto.trabajos.length > 0){
                    oficio.Trabajos = [];
                    presupuesto.trabajos.forEach(trabajo => {
                        if(trabajo.PresupuestarPor == 'BA'){
                            oficio.PresupuestarPor = 'BA';
                        }else{
                            oficio.PresupuestarPor = 'MO';
                        }
                        if(trabajo.IvaReducido == 'N'){
                            oficio.IvaReducido = 'N';
                        }else{
                            oficio.IvaReducido = 'S';
                        }
                        oficio.IVAOfic = trabajo.IvaSeleccionado;                        
                        var precio2 = trabajo.trabajo.precio;
                        var trabajoOficio = {
                            IdTarifa:trabajo.trabajo.id_tarifa,
                            IdTraOfic:trabajo.trabajo.id_categoria,
                            IdLinea:trabajo.trabajo.id_linea,
                            ClaveLinea:trabajo.trabajo.clave_linea,
                            Cantidad:trabajo.Cantidad.toString().replaceAll('.',','),
                            Precio:precio2.toString().replaceAll('.',','),
                            IVABarMO:trabajo.IvaSeleccionado,
                            Urgente:trabajo.Urgente,
                            TotalConIVABarMO:trabajo.TotalConIva.toString().replaceAll('.',',')
                        }
                        if(trabajo.trabajo.visita != 'S'){
                            trabajoOficio.IVABarMO = 0;
                        }
                        total+=trabajo.TotalConIva;
                        oficio.Trabajos.push(trabajoOficio);
                    });
                }
                if(presupuesto.materiales.length > 0){
                    oficio.Materiales = [];
                    presupuesto.materiales.forEach(material => {
                        var precio = 0;
                        if(material.PresupuestarPor == 'BA'){
                            precio = material.trabajo.precioUnidad;
                            oficio.PresupuestarPor = 'BA';
                        }else{
                            precio = material.trabajo.precioUnidad;
                            oficio.PresupuestarPor = 'MO';
                        }
                        if(material.IvaReducido == 'N'){
                            oficio.IvaReducido = 'N';
                        }else{
                            oficio.IvaReducido = 'S';
                        }
                        oficio.IVAOfic = material.IvaSeleccionado;                        
                        var materialOficio = {
                            IdTarifa:material.trabajo.id_tarifa,
                            IdTraOfic:material.trabajo.id_categoria,
                            IdLinea:material.trabajo.id_linea,
                            ClaveLinea:material.trabajo.clave_linea,
                            Cantidad:material.Cantidad.toString().replaceAll('.',','),
                            Precio:precio.toString().replaceAll(".", ","),
                            IVAMat:material.IvaSeleccionado,
                            Descripcion:material.Descripcion,
                            TotalConIVAMat:material.TotalConIva.toString().replaceAll('.',',')
                        }
                        if(material.trabajo.visita != 'S'){
                            materialOficio.IVAMat = 0;
                        }
                        total+=material.TotalConIva;
                        oficio.Materiales.push(materialOficio);
                    });
                }
                if(presupuesto.desplazamiento.length > 0){
                    var desplaza = presupuesto.desplazamiento[0];
                    
                    oficio.Desplazamiento = {
                        IdTarifa:desplaza.trabajo.id_tarifa,
                        IdTraOfic:desplaza.trabajo.id_categoria,
                        IdLinea:desplaza.trabajo.id_linea,
                        ClaveLinea:desplaza.trabajo.clave_linea,
                        Kms:desplaza.Cantidad,
                        KmsPrecio:desplaza.trabajo.precio.toString().replaceAll(".", ","),
                        IVAKms:desplaza.IvaSeleccionado,
                        TotalConIVAKms:desplaza.TotalConIva.toString().replaceAll('.',',')
                    }
                    total+=desplaza.TotalConIva;
                }
                envio.Oficios.push(oficio);
            });
            total = this.redondear(total);
            //envio.TotalPrepValConIVA = total;
            console.log('envio', envio);
            console.log(total);
             
            try{
                var resp = await api.post('servicios/'+ this.id + '/envio-presuval', {envio:envio}); 
                console.log('respobtenida', resp);
                var valoracion = resp['RepairEstimateValuationList']['Valoraciones']['ListadoValoraciones'][0]['Valoracion'][0];
                console.log('presupuestoobtenido', valoracion);
                this.$toast.add({severity:'success', summary: 'Enviada', detail: 'Valoración enviada', life: 2000});
                var ids = [];
                for(let trabajo of this.presupuesto.presupuesto.trabajos){
                    ids.push(trabajo.id_trabajo_presupuesto);
                }
                console.log('ids', ids);
                await api.put('presupuestos/'+ this.presupuesto.presupuesto.presupuestos_id_presupuesto +'/marcar-trabajos-enviados', {ids:ids, id_presuval:valoracion.IdPPTOVAL, version:valoracion.Version});
                await api.put('presupuestos/'+ this.presupuesto.presupuesto.id_factura +'/marcar-enviado', {id_presuval:valoracion.IdPPTOVAL, version:valoracion.Version});
                this.enviandoAxa = false;
                this.mostrarResumen = false;
                this.$emit('enviadoAxa');
            }catch(e){
                this.enviandoAxa = false;
                this.$toast.add({severity:'error', summary: 'Error', detail: e, life: 5000});
                console.error(e);
            }
        },
        redondear(value) {
            return Number.isInteger(value)
                ? value
                : parseFloat(value.toFixed(2));
        },
        async mostrarResumenAxa(){
            if(this.presupuesto.presupuesto.id_presupuesto_compania !='' && this.presupuesto.presupuesto.version !=''){
                alert('Valoración ya enviada a AXA');
                return;
            }
            const api = new PwgsApi();
            this.cargandoResumen = true;
            this.mostrarResumen = true;
            console.log('llega');
            var datos = await api.post('servicios/' + this.id + '/oficios');
            this.afectadosValoraciones = datos.RepairEstimateValuationList.Valoraciones.OficiosAfectado[0].Afectado;
            var temporalesPresu = await api.get('presupuestos/'+ this.presupuesto.presupuesto.presupuestos_id_presupuesto+ '/presuval-axa');
            var temporales = temporalesPresu.filter(trabajo => trabajo.Enviado != 'S');
            console.log('temporales', temporales);
            console.log('presucreado', this.presupuesto);
            var idTrabajoGenerado = [];
            this.presupuesto.presupuesto.trabajos.forEach(trabajo => {
                idTrabajoGenerado.push(trabajo.id_trabajo_presupuesto);
            });
            temporales = temporales.filter(trabajo => idTrabajoGenerado.includes(trabajo.id_trabajo));
            this.gruposAfectadosPresupuestosTemporales = [];
            console.log('temporales2', temporales);
            //recorremos los trabajos obtenidos (los conectados con axa, es decir que tienen parametros de env�o)
            temporales.forEach(tempo => {                
                //buscamos su afectado y especialidad
                console.log('afectados', this.afectadosValoraciones);
                var afectadoEncontrado = this.afectadosValoraciones.find(afectado => afectado.IdAfectado == tempo.IdAfectado);
                var especialidadEncontrada = afectadoEncontrado.Especialidades.find(especialidad => especialidad.IdEspecialidad == tempo.IdEspecialidad && especialidad.Indice == tempo.Indice);
                console.log('tempo', tempo);
                tempo.TotalConIva = this.redondear(parseFloat(tempo.TotalConIva));
                tempo.TotalSinIva = this.redondear(parseFloat(tempo.TotalSinIva));
                //cogemos solo las valoraciones
                if(tempo.TipoPrepVal == 'V'){                  
                    var grupoAfectadoEncontrado = undefined;
                    
                    //AGRUPAMOS LOS TRABAJOS POR AFECTADO

                    //si no hay ningun grupo de afectados, creamos uno
                    if(this.gruposAfectadosPresupuestosTemporales.length == 0){
                        var grupoAfectadoTemporal = {
                            liquidar_cliente: 0,
                            liquidar_reparador: 0,
                            afectado: afectadoEncontrado.NombreAfectado,
                            idAfectado: afectadoEncontrado.IdAfectado,
                            presupuestosTemporales: [],
                        }
                        this.gruposAfectadosPresupuestosTemporales.push(grupoAfectadoTemporal);
                        grupoAfectadoEncontrado = this.gruposAfectadosPresupuestosTemporales[0];
                        console.log('llegacrea');
                    }else{
                        //si hay alguno ya creado, buscamos el que corresponda (aquí nunca pasará ya que solo miramos una valoración)
                        grupoAfectadoEncontrado = this.gruposAfectadosPresupuestosTemporales.find(afectado => afectado.idAfectado == tempo.IdAfectado);
                        console.log('llegaencuentra', this.gruposAfectadosPresupuestosTemporales, grupoAfectadoEncontrado);
                    }
                    // si no hay un grupo de su afectado, lo creamos
                    if(grupoAfectadoEncontrado == undefined){
                        var grupoAfectadoTemporal2 = {
                            afectado: afectadoEncontrado.NombreAfectado,
                            idAfectado: afectadoEncontrado.IdAfectado,
                            presupuestosTemporales: [],
                        }
                        this.gruposAfectadosPresupuestosTemporales.push(grupoAfectadoTemporal2);
                        grupoAfectadoEncontrado = this.gruposAfectadosPresupuestosTemporales[this.gruposAfectadosPresupuestosTemporales.length-1];
                    }
                    
                    //ya tenemos el grupo de afectado al que pertenece, ahora agrupamos de este grupo por su especialidad

                    //si el grupo de afectado al que pertenece no tiene ningun presupuesto, creamos uno
                    if(grupoAfectadoEncontrado.presupuestosTemporales.length == 0){                          
                        console.log('afectadoEncontrado', afectadoEncontrado);                      
                        console.log('especialidadEncontrada', especialidadEncontrada);
                        var grupoPresupuestoTemporal = {
                            especialidad: especialidadEncontrada.NombreEspecialidad,
                            idEspecialidad: especialidadEncontrada.IdEspecialidad,
                            indice:especialidadEncontrada.Indice,
                            totalBaremo:0,
                            totalMateriales:0,
                            totalDesplazamiento:0,
                            totalIva:0,
                            total:0,
                            trabajos: [],
                            materiales: [],
                            desplazamiento:[],
                            comentario:'',
                        };
                        if(tempo.PresupuestarPor == "BA"){
                            grupoPresupuestoTemporal.presupuestarPor = "baremo";
                        }else{
                            grupoPresupuestoTemporal.presupuestarPor = "M.O.";
                        }
                        if(tempo.trabajo.tipo_linea=='Baremo' || tempo.trabajo.tipo_linea=='MO'){
                            grupoPresupuestoTemporal.totalBaremo = tempo.TotalConIva;
                            grupoPresupuestoTemporal.totalIva = tempo.TotalConIva-tempo.TotalSinIva;                          
                            grupoPresupuestoTemporal.total = tempo.TotalConIva;
                            grupoPresupuestoTemporal.trabajos.push(tempo);
                        }else if(tempo.trabajo.tipo_linea=='Materiales'){
                            grupoPresupuestoTemporal.totalMateriales = tempo.TotalConIva;
                            grupoPresupuestoTemporal.totalIva = tempo.TotalConIva-tempo.TotalSinIva;                            
                            grupoPresupuestoTemporal.total = tempo.TotalConIva;
                            grupoPresupuestoTemporal.materiales.push(tempo);
                        }else if(tempo.trabajo.tipo_linea == 'Desplazamiento'){
                            grupoPresupuestoTemporal.totalDesplazamiento = tempo.TotalConIva;
                            grupoPresupuestoTemporal.totalIva = tempo.TotalConIva-tempo.TotalSinIva;                                
                            grupoPresupuestoTemporal.total =  tempo.TotalConIva;
                            grupoPresupuestoTemporal.desplazamiento.push(tempo);
                        }
                       
                        grupoAfectadoEncontrado.presupuestosTemporales.push(grupoPresupuestoTemporal);
                    //Si el grupo de afectado al que pertenece ya tiene algun presupuesto, miramos si hay un grupo para la especialidad en concreto
                    }else{
                        var grupoEncontrado = grupoAfectadoEncontrado.presupuestosTemporales.find(grupo => grupo.idEspecialidad == tempo.IdEspecialidad && grupo.indice == tempo.Indice);
                        //si existe el grupo de especialidad del trabajo lo a�adimos aqu�
                        if(grupoEncontrado){
                            console.log('grupoEncontrado', grupoEncontrado);
                            if(tempo.trabajo.tipo_linea=='Baremo' || tempo.trabajo.tipo_linea=='MO'){
                                grupoEncontrado.totalBaremo = grupoEncontrado.totalBaremo+tempo.TotalConIva;
                                grupoEncontrado.totalIva = grupoEncontrado.totalIva+(tempo.TotalConIva-tempo.TotalSinIva);                                
                                grupoEncontrado.total =  grupoEncontrado.total+tempo.TotalConIva;
                                grupoEncontrado.trabajos.push(tempo);
                            }else if(tempo.trabajo.tipo_linea=='Materiales'){
                                grupoEncontrado.totalMateriales = grupoEncontrado.totalMateriales+tempo.TotalConIva;
                                grupoEncontrado.totalIva = grupoEncontrado.totalIva+(tempo.TotalConIva-tempo.TotalSinIva);                                
                                grupoEncontrado.total =  grupoEncontrado.total+tempo.TotalConIva;
                                grupoEncontrado.materiales.push(tempo);
                            }else if(tempo.trabajo.tipo_linea == 'Desplazamiento'){
                                grupoEncontrado.totalDesplazamiento = grupoEncontrado.totalDesplazamiento+tempo.TotalConIva;
                                grupoEncontrado.totalIva = grupoEncontrado.totalIva+(tempo.TotalConIva-tempo.TotalSinIva);                                
                                grupoEncontrado.total =  grupoEncontrado.total+tempo.TotalConIva;
                                grupoEncontrado.desplazamiento.push(tempo);
                            }
                        //si no existe el grupo de especialidad del trabajo lo creamos
                        }else{
                            var afectadoEncontrado2 = this.afectadosValoraciones.find(afectado => afectado.IdAfectado == tempo.IdAfectado);
                            var especialidadEncontrada2 = afectadoEncontrado2.Especialidades.find(especialidad => especialidad.IdEspecialidad == tempo.IdEspecialidad && especialidad.Indice == tempo.Indice);
                            var grupoPresupuestoTemporal2 = {
                                especialidad: especialidadEncontrada2.NombreEspecialidad,
                                idEspecialidad: especialidadEncontrada2.IdEspecialidad,
                                indice : especialidadEncontrada2.Indice,
                                totalBaremo:0,
                                totalMateriales:0,
                                totalDesplazamiento:0,
                                totalIva:0,
                                total:0,
                                trabajos: [],
                                materiales: [],
                                desplazamiento: [],
                                comentario:'',
                            };
                            if(tempo.PresupuestarPor == "BA"){
                                grupoPresupuestoTemporal2.presupuestarPor = "baremo";
                            }else{
                                grupoPresupuestoTemporal2.presupuestarPor = "M.O.";
                            }
                            if(tempo.trabajo.tipo_linea=='Baremo' || tempo.trabajo.tipo_linea=='MO'){
                                grupoPresupuestoTemporal2.totalBaremo = tempo.TotalConIva;
                                grupoPresupuestoTemporal2.totalIva = tempo.TotalConIva-tempo.TotalSinIva;
                                grupoPresupuestoTemporal2.total = tempo.TotalConIva;
                                grupoPresupuestoTemporal2.trabajos.push(tempo);
                            }else if(tempo.trabajo.tipo_linea=='Materiales'){
                                grupoPresupuestoTemporal2.totalMateriales = tempo.TotalConIva;
                                grupoPresupuestoTemporal2.totalIva = tempo.TotalConIva-tempo.TotalSinIva;
                                grupoPresupuestoTemporal2.total = tempo.TotalConIva;
                                grupoPresupuestoTemporal2.materiales.push(tempo);
                            }else if(tempo.trabajo.tipo_linea == 'Desplazamiento'){
                                grupoPresupuestoTemporal2.totalDesplazamiento = tempo.TotalConIva;
                                grupoPresupuestoTemporal2.totalIva = tempo.TotalConIva-tempo.TotalSinIva;
                                grupoPresupuestoTemporal2.total = tempo.TotalConIva;
                                grupoPresupuestoTemporal2.desplazamiento.push(tempo);
                            }
                            grupoAfectadoEncontrado.presupuestosTemporales.push(grupoPresupuestoTemporal2);
                        }
                    }
                    if(tempo.trabajo.visita=='S' || tempo.trabajo.tipo_linea == 'Desplazamiento'){
                        grupoAfectadoEncontrado.liquidar_reparador += tempo.TotalConIva;
                    }else{
                        grupoAfectadoEncontrado.liquidar_cliente += tempo.TotalConIva;
                    }
                }
                
            });
            console.log('gruposAfectadis', this.gruposAfectadosPresupuestosTemporales);            
            this.gruposAfectadosPresupuestosTemporales.forEach(grupo => {
                grupo.liquidar_cliente = parseFloat(grupo.liquidar_cliente).toFixed(2);
                grupo.liquidar_reparador = parseFloat(grupo.liquidar_reparador).toFixed(2);
                grupo.presupuestosTemporales.forEach(presupuesto => {
                    presupuesto.totalBaremo = parseFloat(presupuesto.totalBaremo).toFixed(2);
                    presupuesto.totalMateriales = parseFloat(presupuesto.totalMateriales).toFixed(2);
                    presupuesto.totalDesplazamiento = parseFloat(presupuesto.totalDesplazamiento).toFixed(2);
                    presupuesto.total = parseFloat(presupuesto.total).toFixed(2);
                    presupuesto.totalIva = parseFloat(presupuesto.totalIva).toFixed(2);
                })
            })
            this.cargandoResumen = false;
        },
        descargar(link){
            //let urlglobal = localStorage.getItem('direccion');
            console.log('link', link);
            window.open(link, "width=800, height=600");
        }, 
        sacarfecha(fecha) {
            let fechaaux = fecha.split(' ');
            let horaaux = fechaaux[1].split(':');
            console.log("fechaaus", fechaaux);
            return fechaaux[0]+" "+(parseInt(horaaux[0])+2)+":"+horaaux[1];
        },
        comprobarCodigo(){
            if(this.servicio){
                this.codigo='Exp.'+this.servicio.codigo_original;
                if(this.servicio.compania.sistema=="P.A.P"){
                    this.pap=true;
                }
                this.obtenerGenerados();
            }
        }, 
        async guardarForm(idDoc){
            if(this.emailIntroducido[idDoc]==''){
                alert('Introduce un email');
                return;
            }
            if(this.ta[idDoc]==''){
                alert('Introduce un texto');
                return;
            }
            const api = new PwgsApi();
            var body = {'tipo_envio': this.envioSeleccionado[idDoc], 'formato':this.docSeleccionado[idDoc],
                'email':this.emailIntroducido[idDoc],'texto':this.ta[idDoc],'asunto':this.asuntoSeleccionado[idDoc]};
            if(this.pap){
                body.pap = this.PAPSeleccionado[idDoc];
            }
            await api.put('servicios/'+this.id+'/enviar-gestion-doc/'+idDoc,body);
            this.generadosVisible = false;
            this.cargarnuevos();
      },
      confirmarEliminar(idDoc){
        this.$confirm.require({
            message: '¿Seguro que quieres eliminar el documento?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            rejectClass: 'p-button-secondary p-button-outlined',
            rejectLabel: 'Cancelar',
            acceptLabel: 'Aceptar',
            accept: () => {
            this.eliminarDoc(idDoc)
            },
            reject: () => {
                return;
            }
        });          
      },
      async eliminarDoc(idDoc){
          const api = new PwgsApi();
          await api.delete('/servicios/'+this.id+'/gestion-doc/'+idDoc);
          this.generadosVisible = false;
          this.generadosVisible = false;
          this.cargarnuevos();
      },    
        obtenerGenerados(){
            
            try{
                this.docsGenerados = [];
                this.docsSeparados = [];
                this.docsEnviados = [];
                this.docsGenerados = this.presupuesto.gestiondoc_generados;
                for(let docs of this.docsGenerados){
                    this.docsEnviados[docs.id_documento_generado] = docs.envios;
                    var nombre = docs.datos_documento.nombre;
                    if(this.docsSeparados[nombre]){
                        this.docsSeparados[nombre].push(docs);
                    }else{
                        this.docsSeparados[nombre]=[docs];
                    }
                    if (!this.botones[docs.id_documento_generado]) {
                        this.botones[docs.id_documento_generado] = [];
                    }
                    this.visibleForm[docs.id_documento_generado] = false;
                    this.visibleEnvios[docs.id_documento_generado] = false;
                    this.extensiones[docs.id_documento_generado] = docs.datos_documento.extension;
                    this.tipo_doc_pap[docs.id_documento_generado] = docs.tipo_doc_pap;
                    this.envioSeleccionado[docs.id_documento_generado]='email';
                    this.docSeleccionado[docs.id_documento_generado]='pdf';
                    this.PAPSeleccionado[docs.id_documento_generado]='';
                    this.emailSeleccionado[docs.id_documento_generado]='';
                    this.emails[docs.id_documento_generado]=docs.emails;
                    this.emailIntroducido[docs.id_documento_generado]='';
                    this.ta[docs.id_documento_generado]='';
                    this.asuntoSeleccionado[docs.id_documento_generado]=this.codigo;
                    if(docs.ruta_generado){
                        const ruta = docs.ruta_generado.toLowerCase();
                        if(ruta.includes('.docx')){
                            this.botones[docs.id_documento_generado].push('docx')
                        }else{
                            this.botones[docs.id_documento_generado].push('excel')
                        }
                    }
                    if(docs.ruta_pdf_generado){
                        this.botones[docs.id_documento_generado].push('pdf')
                    }
                    if(docs.ruta_png_generado){
                        this.botones[docs.id_documento_generado].push('png')
                    }
                    if(docs.ruta_pdf_generado_firmado){
                        this.botones[docs.id_documento_generado].push('pdff')
                    }
                }
                this.generadosVisible = true;
            }catch(e){
                console.log('sin docs generados',e)
            }
        },
        async generarDocumento(){
            if (this.documentoSeleccionado != 'sin doc') {
            
            const api = new PwgsApi();
            
                var body = {'seccion': 'presupuestos', 'id_seccion':this.$props.idfactura, 'id_documento':this.documentoSeleccionado,ids_documentos:this.$props.idfotosseleciconadas};
                await api.post('/servicios/'+this.id+'/generar-gestion-doc', body);
                this.generadosVisible = false;
                this.$toast.add({severity: 'success', summary:'Generado', detail: 'Documento generado', life: 2000});
                this.cargarnuevos();
            
          }else{
              alert('Selecciona un documento');
          }
      },
      async cargarnuevos(){
          const api = new PwgsApi();
          try{
              this.generadosVisible = false;
              var datos = await api.get('presupuestos/' + this.$props.id + '/presupuestos-generados');
              var fac = '';
              datos.forEach(element => {
                if(element.presupuesto.id_factura==this.$props.idfactura){
                    fac = element;
                }
              });
              var docus = fac.gestiondoc_generados;
              this.docsGenerados = [];
              this.docsSeparados = [];
              this.docsEnviados = [];
              this.docsGenerados = docus;
              for(let docs of this.docsGenerados){
                  this.docsEnviados[docs.id_documento_generado] = docs.envios;
                  var nombre = docs.datos_documento.nombre;
                  if(this.docsSeparados[nombre]){
                      this.docsSeparados[nombre].push(docs);
                  }else{
                      this.docsSeparados[nombre]=[docs];
                  }
                  if (!this.botones[docs.id_documento_generado]) {
                      this.botones[docs.id_documento_generado] = [];
                  }
                  
                  this.visibleForm[docs.id_documento_generado] = false;
                  this.visibleEnvios[docs.id_documento_generado] = false;
                  this.extensiones[docs.id_documento_generado] = docs.datos_documento.extension;
                  this.tipo_doc_pap[docs.id_documento_generado] = docs.tipo_doc_pap;
                  this.envioSeleccionado[docs.id_documento_generado]='email';
                  this.docSeleccionado[docs.id_documento_generado]='pdf';
                  this.PAPSeleccionado[docs.id_documento_generado]='';
                  this.emailSeleccionado[docs.id_documento_generado]='';
                  this.emails[docs.id_documento_generado]=docs.emails;
                  this.emailIntroducido[docs.id_documento_generado]='';
                  this.ta[docs.id_documento_generado]='';
                  this.asuntoSeleccionado[docs.id_documento_generado]=this.codigo;
                  
                  if(docs.ruta_generado){
                      const ruta = docs.ruta_generado.toLowerCase();
                      if(ruta.includes('.docx')){
                          this.botones[docs.id_documento_generado].push('docx')
                      }else{
                          this.botones[docs.id_documento_generado].push('excel')
                      }
                  }
                  if(docs.ruta_pdf_generado){
                      this.botones[docs.id_documento_generado].push('pdf')
                  }
                  if(docs.ruta_png_generado){
                      this.botones[docs.id_documento_generado].push('png')
                  }
                  if(docs.ruta_pdf_generado_firmado){
                      this.botones[docs.id_documento_generado].push('pdff')
                  }
              }
              this.generadosVisible = true;
          }catch(e){
              console.error('No hay docus. ', e);
          }
      }, 
        async obteneDocumentosPresupuesto(){
          this.cargandoDocumentos = true;
          const api = new PwgsApi();
          const resp = await api.get('/servicios/'+this.id+'/gestion-doc?tipo=presupuestos');
          this.documentosPresupuesto = resp.gestiondoc.presupuestos;
          if(this.documentosPresupuesto && this.documentosPresupuesto.length>0){
            this.mostrarBotonGestor = true;
          }
          this.cargandoDocumentos = false;
      }, 
        comprobarGestorDoc(){
            if(this.mostrarGestor == true){
                this.mostrarGestor = false;
            }else{
                this.mostrarGestor = true;
            }
        },
        async desaprobar(id) { 
            //PUT  modulos/pwgsapi/index.php/presupuestos/:id_factura/modificar-estado-presupuesto
            const api = new PwgsApi();
            if (this.estado == 0){ 
                this.estado = 1; this.estado_aprobado = true; 
            } else {
                this.estado = 0; this.estado_aprobado = false; 
            }
            let subidadatos = { estado: this.estado };
            try {
                await api.put('presupuestos/' + id + '/modificar-estado-presupuesto', subidadatos);
                this.$parent.cargar_presupuestos_generados();
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });
            }
            catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'El trabajo no se puede modificar ya que está incluido en otro presupuesto generado', life: 5000 });
            }
        },
        async estadoPresupuesto(id,estado) { 
            //PUT  modulos/pwgsapi/index.php/presupuestos/:id_factura/modificar-estado-presupuesto
            const api = new PwgsApi();
            let subidadatos = { estado: estado };
            try {
                await api.put('presupuestos/' + id + '/modificar-estado-presupuesto', subidadatos);
                this.$parent.cargar_presupuestos_generados();
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });
            }
            catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'El trabajo no se puede modificar ya que está incluido en otro presupuesto generado', life: 5000 });
            }
        },
        async cargaremails() {           
            //GET  modulos/pwgsapi/index.php/servicios/:id/emails
            const api = new PwgsApi();
            let aux;
            aux = await api.get('servicios/' + this.$props.id + '/emails');
            for (let i = 0; i < aux.length; i++){
                this.emailsPresu[i] = { tipo:aux[i].tipo,email:[] };
                if (aux[i].emails) {
                    for (let j = 0; j < aux[i].emails.length; j++) {
                        this.emailsPresu[i].email[j] = aux[i].emails[j].email;
                    }
                }
            }
        },
        cargardatos() { 
            this.envios_presupuesto = this.$props.presupuesto.envios_presupuesto;
            if(this.envios_presupuesto.length > 0){
                this.mostrarEnvios = true;
            }
            this.url = this.$props.presupuesto.url_completa_descarga_pdf;
            this.urlexcel = this.$props.presupuesto.url_completa_descarga_excel;
            this.datosurl = this.datosurl + this.url + "'";
            this.datosexcel = this.datosexcel + this.urlexcel + "'";
            this.estado = this.$props.presupuesto.presupuesto.presupuesto_activo_factura;
            if (this.estado == 1){ 
                this.estado_aprobado = true; 
            }else{
                this.estado_aprobado = false; 
            }
            this.cargaremails();
            if(this.servicio.compania.sistema == 'AXA_WS'){
                if(this.$props.presupuesto.presupuesto.trabajos.length > 0){
                    this.presupuesto.presupuesto.trabajos.forEach(trabajo => {
                        if(trabajo.parametros_envio == ''){
                            this.axaCorrecto = false;
                        }
                    })
                }else{
                    this.axaCorrecto = false;
                }
            }else{
                this.axaCorrecto = false;
            }
        },
        async enviarpresupuesto() {
            //PUT  modulos/pwgsapi/index.php/presupuestos/:id_factura/enviar-presupuesto
            let todoscorreos = [];
            let correossubida = [];
            
            if (this.otrosdestinatarios) {                
                todoscorreos = this.otrosdestinatarios.split(";");                
            }
            console.log('todoscorreos', todoscorreos);
            correossubida = this.emailsenviar.concat(todoscorreos);
            console.log('correossubida', correossubida);

            try {
                const api = new PwgsApi();
                
                let subidadatos = { tipo: this.tipodeenvio, emails: correossubida, id_servicio:this.id, descripcion_email:  this.descripcionemail};
                await api.put('presupuestos/' + this.$props.idfactura + '/enviar-presupuesto', subidadatos);
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Presupuesto enviado', life: 2000 });
                this.$emit('enviado');
                
                var presupuestos = this.datospresupuestos = await api.get('presupuestos/' + this.$props.id + '/presupuestos-generados');
                var presupuesto = presupuestos.find(presupuesto => presupuesto.presupuesto.id_factura == this.$props.idfactura);
                console.log('presupuesto', presupuesto);                
                this.envios_presupuesto = presupuesto.envios_presupuesto;
                if(this.envios_presupuesto.length > 0){
                    this.mostrarEnvios = true;
                }
            }
            catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
            }
        },
        async anular(id) {
            if (window.confirm("¿Quiere anular el presupuesto?")) {
                //PUT  modulos/pwgsapi/index.php/presupuestos/:id_factura/anular-presupuesto-generado
                const api = new PwgsApi();
                let subidadatos = { id_factura: id };
                try {
                    await api.put('presupuestos/' + id + '/anular-presupuesto-generado', subidadatos);
                    this.$parent.cargar_presupuestos_generados();
                    this.$toast.add({ severity: 'success', summary: 'Anulado', detail: 'Presupuesto Anulado', life: 2000 });
                    this.$parent.$parent.$parent.toggleactualizar();
                }
                catch (error) {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Error', life: 5000 });
                }
            }
        },
         async eliminar(id) { 
            if (window.confirm("¿Quiere eliminar el presupuesto?")) {

                const api = new PwgsApi();
                let subidadatos = { id_factura: id };
                try {
                    await api.delete('presupuestos/' + id + '/eliminar-presupuesto-generado', subidadatos);
                    this.$parent.cargar_presupuestos_generados();
                    this.$toast.add({ severity: 'success', summary: 'Eliminado', detail: 'Presupuesto Eliminado', life: 2000 });
                    this.$parent.$parent.$parent.toggleactualizar();
                }   
                catch (error) {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Error', life: 5000 });
                }

            }
        }
    },
    mounted() {
        //let aux = localStorage.getItem('direccion');
        this.comprobarCodigo();
        this.cargardatos();
        this.obteneDocumentosPresupuesto();
    },
    watch: {
        servicio() {
            this.comprobarCodigo();
        },
        emailSeleccionado:{
            handler(newVal) {
                Object.keys(newVal).forEach(idDoc => {
                    this.emailIntroducido[idDoc] = newVal[idDoc];
                });
            },
            deep: true
        }
    }
})



</script>